import React, { useContext } from "react";
import { observer } from "mobx-react";
import classNames from "classnames";

import { EventContext } from "@gp/components";
import { EventKeyBettingOffer } from "@gp/models";
import { toDisplayOdd } from "@gp/utility";
import { useRootAppStore } from "@hooks";
import { EventKeyOffer } from "@gp/offer";

export const OutrightOfferRowOfferButton = observer(
	function OutrightOfferRowOfferButton(props: {
		tip: EventKeyBettingOffer;
		eventKey: EventKeyOffer;
	}) {
		const event = useContext(EventContext);
		const betSlipStore = useRootAppStore().betSlipStore;
		const displayTipValue = toDisplayOdd(props.tip.value);

		const isSelected = betSlipStore.isTipSelected(props.tip.id);
		const isDisabled =
			props.tip.isLocked || event.isLocked || props.eventKey.isLocked;

		const btnClasses = classNames(
			"quote--special__odd quote quote--button",
			{
				"one-click": betSlipStore.isOneClickBetActive,
				"is-active": isSelected,
				desc: props.tip.indicator === -1,
				inc: props.tip.indicator === 1,
			}
		);

		return (
			<button
				key={props.tip.id}
				type="button"
				className={btnClasses}
				title={displayTipValue}
				disabled={isDisabled}
				onClick={() => betSlipStore.addRemoveOffer(props.tip)}
			>
				{displayTipValue}
			</button>
		);
	}
);
